import { render, staticRenderFns } from "./language-select.vue?vue&type=template&id=6d9e3033&"
import script from "./language-select.vue?vue&type=script&lang=js&"
export * from "./language-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports